var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBikeGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_4560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.21875 21.0938C6.08271 21.0938 7.59375 19.5827 7.59375 17.7188C7.59375 15.8548 6.08271 14.3438 4.21875 14.3438C2.35479 14.3438 0.84375 15.8548 0.84375 17.7188C0.84375 19.5827 2.35479 21.0938 4.21875 21.0938Z",
    stroke: "#828FA3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7812 21.0938C24.6452 21.0938 26.1562 19.5827 26.1562 17.7188C26.1562 15.8548 24.6452 14.3438 22.7812 14.3438C20.9173 14.3438 19.4062 15.8548 19.4062 17.7188C19.4062 19.5827 20.9173 21.0938 22.7812 21.0938Z",
    stroke: "#828FA3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.84375 10.125C2.40469 10.125 10.125 10.9688 10.6313 17.7188H16.0312C16.0312 17.7188 16.875 10.9688 25.3125 10.9688",
    stroke: "#828FA3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91876 11.8126H10.5469C12.3609 11.8126 14.8078 9.57661 17.7188 7.42505",
    stroke: "#828FA3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5.90625H16.4531C16.875 5.90625 17.1281 6.28594 17.3391 6.66563C17.55 7.04531 22.7812 17.7188 22.7812 17.7188M12.6562 14.3438L4.21875 17.7188",
    stroke: "#828FA3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_4560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBikeGrey);
export default __webpack_public_path__ + "static/media/icon-bike-grey.765f472a1cbda6059f860204bf815bd9.svg";
export { ForwardRef as ReactComponent };